import { render } from "./TableBody.vue?vue&type=template&id=0f5f3369&ts=true"
import script from "./TableBody.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableBody.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/table/TableBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f5f3369"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f5f3369', __exports__)) {
    api.reload('0f5f3369', __exports__)
  }
  
  module.hot.accept("./TableBody.vue?vue&type=template&id=0f5f3369&ts=true", () => {
    api.rerender('0f5f3369', render)
  })

}


export default __exports__